import React, { useEffect, useState } from 'react';
import { useAddOrganization, useDeleteOrganization, useFetchOrganizations } from '../../hooks/api/organisation/organisation';
import { toast } from 'react-toastify';
import { Pagination } from '@mui/material';

const organizationsData = [
 ];

const OrganizationManagement = () => {
  const [filters, setFilters]=useState({
      orgId:"",
      search:"",
      pageNumber:1,
      pageSize:10
  }) 
  const fetchOrganisationAPI= useFetchOrganizations(filters)
  const addOrganisationAPI= useAddOrganization()
  const deleteOrganisationAPI= useDeleteOrganization()

    const [organizations, setOrganizations] = useState(organizationsData);
  const [newOrganization, setNewOrganization] = useState({ name: '', contactEmail: '', contactPhone: '' });
  const [editOrganization, setEditOrganization] = useState(null);

  const handleInputChange = (e) => {
    setNewOrganization({ ...newOrganization, [e.target.name]: e.target.value });
  };

  const handleAddOrganization = () => {


      toast.dismiss()
      toast.loading(`Adding Project`)
        addOrganisationAPI.mutate({...newOrganization,
          status:"active"
        },
            {
                onSuccess(addProjectResponse){
    toast.dismiss()
    toast.success(`Organisation Added Successfully`)
    setOrganizations([...organizations, { id: organizations.length + 1, ...newOrganization }]);
}, 
                onError: (error) => {
                    console.log({error})
                    toast.dismiss()
                    toast.error(   `Unable to add Projects`)
                }
    
            }
        )

      setNewOrganization({ name: '', contactEmail: '', contactPhone: '' });
  };

  const handleDeleteOrganization = (id) => {
    const isDelete= window.confirm(`Are you sure you want to delete this organization?`)
    if(isDelete){
      toast.dismiss()
      toast.loading(`Adding Project`)
        deleteOrganisationAPI.mutate(id,
            {
                onSuccess(addProjectResponse){
    toast.dismiss()
    toast.success(`Organisation Deleted Successfully`);
      setOrganizations(organizations.filter((org) => org.id !== id));
}, 
                onError: (error) => {
                    console.log({error})
                    toast.dismiss()
                    toast.error(   `Unable to delete Organisation`)
                }
    
            }
        )

    }

  
  };

  const handleEditOrganization = (org) => {
    setEditOrganization({ ...org });
  };

  const handleUpdateOrganization = () => {
    setOrganizations(
      organizations.map((org) => (org.id === editOrganization.id ? { ...org, ...editOrganization } : org))
    );
    setEditOrganization(null);
  };


  useEffect(()=>{
    if(fetchOrganisationAPI.data){

        setOrganizations(fetchOrganisationAPI.data?.orgs)
    }
  }, [fetchOrganisationAPI.data])
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Organization Management</h1>

      {/* Add Organization Form */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-4">
        <h2 className="text-xl font-semibold mb-2">Add New Organization</h2>
        <div className="grid grid-cols-2 gap-4">
          <input
            type="text"
            name="name"
            placeholder="Organization Name"
            value={newOrganization.name}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
          <input
            type="email"
            name="contactEmail"
            placeholder="Contact Email"
            value={newOrganization.contactEmail}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
          <input
            type="tel" // Use tel input type for phone numbers
            name="contactPhone"
            placeholder="Contact Phone"
            value={newOrganization.contactPhone}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
        </div>
        <button
          onClick={handleAddOrganization}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Add Organization
        </button>
      </div>

      {/* Organization Table */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-2">Organization List</h2>
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left">Name</th>
              <th className="px-4 py-2 text-left">Contact Email</th>
              <th className="px-4 py-2 text-left">Contact Phone</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {organizations.map((org) => (
              <tr key={org.id}>
                <td className="px-4 py-2">{org.name}</td>
                <td className="px-4 py-2">{org.contactEmail}</td>
                <td className="px-4 py-2">{org.contactPhone}</td>
                <td className="px-4 py-2 flex gap-2">
                  <button
                    onClick={() => handleEditOrganization(org)}
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteOrganization(org.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

             <Pagination count={fetchOrganisationAPI.data?.pagination?.totalPages} page={filters.pageNumber} onChange={ (event, value) => {
              setFilters(prev=>({...prev, pageNumber:value}))
            }} />
      </div>

      {/* Edit Organization Form (Conditional Rendering) */}
      {editOrganization && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-2">Edit Organization</h2>
            <input
              type="text"
              name="name"
              value={editOrganization.name}
              onChange={(e) => setEditOrganization({ ...editOrganization, name: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
              required
            />
            <input
              type="email"
              name="contactEmail"
              value={editOrganization.contactEmail}
              onChange={(e) => setEditOrganization({ ...editOrganization, contactEmail: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
              required
            />
            <input
              type="tel"
              name="contactPhone"
              value={editOrganization.contactPhone}
              onChange={(e) => setEditOrganization({ ...editOrganization, contactPhone: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
              required
            />
            <button
              onClick={handleUpdateOrganization}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
            >
              Update
            </button>
            <button
              onClick={() => setEditOrganization(null)}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganizationManagement;